export default __webpack_public_path__ + "static/media/logo-head.0caa6127.svg";